import React, { Component } from "react";
import { Grid } from "@material-ui/core";

import { connect } from "react-redux";
import { compose } from 'redux';
import MyOpenTasks from "./MyOpenTasks"
import PipelineSummary from "../SalesTab/PipelineSummary"
import SalesPerformance from "../SalesTab/SalesPerformance"
import LatestActivity from "../ActivityTab/LatestActivity"
import CommanDateFilter from "../CommanDateFilter"
import CrmOverview from "./CrmOverview"
import DealsSummary from "./DealsSummary"

class SummaryDashboard extends Component {
  state = {
    crmOverview: {},
    dealsSummary: {},
  };

  handlePipelineData = (crmOverview, dealsSummary) => {
    this.setState({ crmOverview, dealsSummary });
  }

  render() {
    const { crmOverview, dealsSummary } = this.state;

    return (
      <React.Fragment>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <CommanDateFilter />
          </Grid>

          {/* Pipeline Summary & Sales Performance */}
          <Grid item xs={12} md={6}>
            <PipelineSummary onPipelineData={this.handlePipelineData} />
          </Grid>
          <Grid item xs={12} md={6}>
            <SalesPerformance />
          </Grid>

          {/* CRM Overview — full width */}
          <Grid item xs={12}>
            <CrmOverview crmOverview={crmOverview} />
          </Grid>

          {/* Deals Summary — full width */}
          <Grid item xs={12}>
            <DealsSummary dealsSummary={dealsSummary} />
          </Grid>

          {/* Tasks & Activity */}
          <Grid item xs={12} md={6}>
            <MyOpenTasks />
          </Grid>
          <Grid item xs={12} md={6}>
            <LatestActivity />
          </Grid>
        </Grid>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({ });
const mapDispatchToProps = dispatch => ({ });

export default compose(connect(mapStateToProps, mapDispatchToProps))(SummaryDashboard);
